import styles from './style.postcss';

import React, { PureComponent } from 'react';
import { AttendanceStatus, getDisplayName } from 'data/SessionsAttendance/status';
import is from 'is_js';
import { Tooltip, Icon, testClass } from 'omni-common-ui';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const DASH = '-';

class AttendanceCell extends PureComponent {
  _getDisplayConfig() {
    const { attendanceStatus } = this.props;
    const presentClassName = classnames(styles.__present, testClass('present'));
    const absentClassName = classnames(styles.__absent, testClass('absent'));
    const lateClassName = classnames(styles.__late, testClass('late'));
    switch (attendanceStatus) {
      case AttendanceStatus.present:
        return { img: 'success', text: getDisplayName(AttendanceStatus.present), class: presentClassName };
      case AttendanceStatus.absent:
        return { img: 'cross-circle', text: getDisplayName(AttendanceStatus.absent), class: absentClassName };
      case AttendanceStatus.late:
        return { img: 'clock', text: getDisplayName(AttendanceStatus.late), class: lateClassName };
      case AttendanceStatus.unmarked:
        return { img: 'circle', text: getDisplayName(AttendanceStatus.unmarked) };
      case AttendanceStatus.notapplicable:
        return { text: getDisplayName(AttendanceStatus.notapplicable) };
      default:
        throw new Error(`Invalid attendance status: ${attendanceStatus}`);
    }
  }

  _renderStatusTooltip() {
    const { isFutureSession, attendanceStatus } = this.props;
    if (isFutureSession === true) {
      return DASH;
    }

    if (is.not.string(attendanceStatus)) {
      return DASH; // In case the API returns something strange.
    }

    const displayConf = this._getDisplayConfig();
    return <Tooltip text={displayConf.text}>
      {this._renderStatusView(displayConf)}
    </Tooltip>;
  }

  _renderStatusView(displayConf) {
    const { attendanceStatus } = this.props;
    if (attendanceStatus === AttendanceStatus.notapplicable) {
      return 'n/a';
    }

    return <Icon id={displayConf.img}
        className={classnames(styles.AttendanceCell_img, displayConf.class)} />;
  }

  render() {
    const className = classnames(styles.AttendanceCell,
      testClass('attendance-cell'));
    return <div className={className}>
      {this._renderStatusTooltip()}
    </div>;
  }
}

AttendanceCell.propTypes = {
  isFutureSession: PropTypes.bool,
  attendanceStatus: PropTypes.oneOf(Object.keys(AttendanceStatus)),
};

export default AttendanceCell;



// WEBPACK FOOTER //
// ./containers/Group/Attendance/MarkAttendance/MarkAttendanceCourseView/AttendanceCell/index.jsx